module.exports = __webpack_public_path__ + "static/media/dashed-circle.9ed2097f.svg";